import { render, staticRenderFns } from "./AppRoot.vue?vue&type=template&id=31feeb80&scoped=true&"
import script from "./AppRoot.vue?vue&type=script&lang=js&"
export * from "./AppRoot.vue?vue&type=script&lang=js&"
import style0 from "./AppRoot.vue?vue&type=style&index=0&id=31feeb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31feeb80",
  null
  
)

export default component.exports